import React, { useEffect, useMemo } from 'react';
import { differenceBy } from 'lodash';
import { useCollect } from 'hooks';

import Show from 'components/Show';
import Modal from 'components/Modal';
import Nothing from 'components/Misc/Nothing';
import Progress from 'components/Misc/Progress';
import { Button } from 'components/Misc/Form';

import Grade from 'containers/Administrator/Articles/Profile/Grades/Grade';

import { useArticleGradeStore } from 'store/article/useArticleGradeStore';

const Add = ({ modal, handleModal }) => {
	// Use article's grade store
	const selected = useArticleGradeStore(state => state.grades);

	// Store request parameters
	const parameters = useMemo(() => ({
		eager: '[program]'
	}), []);

	// Store collected grades
	const [[grades, progress], collect] = useCollect('grades', parameters);

	// Store available grades
	const available = useMemo(() =>
		differenceBy(grades, selected, 'id') ?? []
	, [grades, selected]);

	// Collect grades on mount
	useEffect(() => {
		(async () => await collect())();
	}, [collect]);

	return (
		<Modal title="Pievienot klasi" visible={modal} handleModal={handleModal}>
			<div className="space-y-4">
				{/* List available grades for selection */}
				<Show if={available.length && !progress}>
					<div className="grid md:grid-cols-2 gap-4">
						{available?.map(grade =>
							<Grade key={grade.id} grade={grade} />
						)}
					</div>
				</Show>

				{/* Show loading progress */}
				<Progress progress={progress} />
			
				{/* Show nothing */}
				<Nothing visible={!available?.length && !progress} />

				{/* Modal's controls */}
				<div className="flex justify-end">
					<Button
						icon="check"
						theme="success"
						value="Saglabāt"
						onClick={handleModal}
					/>
				</div>
			</div>
		</Modal>
	);
};

export default Add;